import { sanguine, ultraMarine } from '@cogneed/react-utils';
import { Box, styled } from '@mui/material';

const StyledBox = styled(Box)({
  display: 'flex',
  gap: 4,

  '& > .MuiBox-root': {
    display: 'flex',
    alignItems: 'center',
    gap: 2,
    color: ultraMarine[400],
    '& > .MuiTypography-body1': {
      fontSize: 10,
      fontWeight: 600,
    },
    '& > .MuiSvgIcon-root': {
      height: 14,
      width: 14,
    },
    '&:first-of-type': {
      color: sanguine[400],
    },
  },
});

export default StyledBox;
